import React from 'react';
import s from "./CommercialBanking.module.css";
import { motion } from 'framer-motion';
import comercial_image from '../../assets/img/comercialBanking.png';
import Hero from '../../components/hero/Hero';
import { useTranslation } from 'react-i18next';
import {Helmet} from "react-helmet-async";

const CommercialBanking = () => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>

      <Helmet>
        <title>Commercial Banking Solutions for Businesses | Wall Street IBU</title>
        <meta
            name="description"
            content="Professional commercial banking services for SMEs and corporations. Manage business accounts,
            payments, and global/international transactions with Wall Street IBU."
        />
        <meta name="keywords" content="commercial banking services, international business banking, corporate banking
        services"/>
      </Helmet>

      <motion.div
        initial={{ opacity: 0, scale: 1 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className={s.motion_div}
      >
        <div className={s.content}>
          <Hero
            title_1={t('commercialBanking.hero.title_1')}
            title_2={t('commercialBanking.hero.title_2')}
            description={t('commercialBanking.hero.description')}
          />

          <div className={s.comercial_block_desc}>
            <div className={s.comercial_block_desc_left}>
              <img
                className={s.desc_image}
                src={comercial_image}
                alt={t('commercialBanking.altText', 'Commercial Banking Description')}
              />
            </div>
            <div className={s.comercial_block_desc_right}>
              <p className={s.comercial_block_desc_paragraph}>
                {t('commercialBanking.commercial_block_desc.paragraph1')}
              </p>
              <p className={s.comercial_block_desc_paragraph}>
                {t('commercialBanking.commercial_block_desc.paragraph2')}
              </p>
              <p className={s.comercial_block_desc_paragraph}>
                {t('commercialBanking.commercial_block_desc.paragraph3')}
              </p>
            </div>
          </div>

          <div className={s.services_list_block}>
            <div className={s.services_list_block_title}>
              <div>
              <br/>{t('commercialBanking.services_list_block.title')}
              </div>
            </div>
            <div className={s.flex}>
              <div className={s.left}>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('commercialBanking.services_list_block.left.line1')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('commercialBanking.services_list_block.left.line2')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('commercialBanking.services_list_block.left.line3')}
                  </div>
                </div>
              </div>
              <div className={s.right}>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('commercialBanking.services_list_block.right.line1')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle} />
                  <div className={s.line_text}>
                    {t('commercialBanking.services_list_block.right.line2')}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={s.gradient}>
            <div className={s.gradient_title}>
              {t('commercialBanking.gradient.title')}
            </div>
            <div className={s.flex}>
              <div className={s.left}>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.left.line1')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.left.line2')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.left.line3')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.left.line4')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.left.line5')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.left.line6')}
                  </div>
                </div>
              </div>
              <div className={s.right}>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.right.line1')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.right.line2')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.right.line3')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.right.line4')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.right.line5')}
                  </div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle}/>
                  <div className={s.gradient_text}>
                    {t('commercialBanking.gradient.right.line6')}
                  </div>
                </div>
              </div>
            </div>
            <div className={s.gradient_footer}>
              {t('commercialBanking.gradient.footer')}
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default CommercialBanking;
